import { ProductsGrid } from '@ui/product/products-grid.tsx';
import { ListStatus } from './list-status.tsx';
import { useProducts } from '../../entites/product';

export const SearchProducts = ({ query }: { query: string }) => {
  const { data, rawData } = useProducts({ query });

  if (!query) return <ListStatus variant="initial" />;

  if (!rawData || data.length === 0) return <ListStatus variant="empty" />;

  return <ProductsGrid items={data} />;
};
